export default "__VITE_ASSET__BEa8yjaE__"